import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import GameStatistic from "./reportComponents/GameStatistic";
/*player Components*/

import { useHistory, useLocation } from "react-router-dom";
import { useUserRights } from "../../contexts/UserRightsContext";
import AccountChanges from "../common/report/AccountChanges";
import ActionByGame from "../common/report/ActionByGame";
import ActionByPlayer from "../common/report/ActionByPlayer";
import ActionHistory from "../common/report/ActionHistory";
import ActionPercentByGame from "../common/report/ActionPercentByGame";
import Adjustment from "../common/report/Adjustment";
import AgentBalance from "../common/report/AgentBalance";
import AgentCallsLog from "../common/report/AgentCallsLog";
import AgentHoldPercent from "../common/report/AgentHoldPercent";
import AgentPerHead from "../common/report/AgentPerHead";
import AgentPosition from "../common/report/AgentPosition";
import AtRistkByAgent from "../common/report/AtRistkByAgent";
import BalanceHistoryByAgent from "../common/report/BalanceHistoryByAgent";
import BalanceHistoryByPlayer from "../common/report/BalanceHistoryByPlayer";
import CallsLog from "../common/report/CallsLog";
import CashFlow from "../common/report/CashFlow";
import CashFlowByPayment from "../common/report/CashFlowByPayment";
import CashFlowBySource from "../common/report/CashFlowBySource";
import ChangedWagers from "../common/report/ChangedWagers";
import ChangesByGame from "../common/report/ChangesByGame";
import DailySummary from "../common/report/DailySummary";
import DailySummaryChart from "../common/report/DailySummaryChart";
import DistributionDefault from "../common/report/DistributionDefault";
import DistributionDetails from "../common/report/DistributionDetails";
import DistributionHoldPercent from "../common/report/DistributionHoldPercent";
import FinalStatsByAgent from "../common/report/FinalStatsByAgent";
import FreePlays from "../common/report/FreePlays";
import GameScore from "../common/report/GameScore";
import GameStarted from "../common/report/GameStarted";
import GameStatistics from "../common/report/GameStatistics";
import GrossAmount from "../common/report/GrossAmount";
import GrossWeek from "../common/report/GrossWeek";
import GroupingBalance from "../common/report/GroupingBalance";
import LineHistory from "../common/report/LineHistory";
import LineHistoryByAgent from "../common/report/LineHistoryByAgent";
import MailingList from "../common/report/MailingList";
import ParlayTeaserExposure from "../common/report/ParlayTeaserExposure";
import PersonalInfo from "../common/report/PersonalInfo";
import PlayerActivity from "../common/report/PlayerActivity";
import PlayerCountByAgent from "../common/report/PlayerCountByAgent";
import PlayerDeleted from "../common/report/PlayerDeleted";
import PlayerListing from "../common/report/PlayerListing";
import Settle from "../common/report/Settle";
import SignOnStatus from "../common/report/SignOnStatus";
import SignUp from "../common/report/SignUp";
import StatisticsByGame from "../common/report/StatisticsByGame";
import SummaryCallActivity from "../common/report/SummaryCallActivity";
import TimeStatusChanges from "../common/report/TimeStatusChanges";
import TopPlayer from "../common/report/TopPlayer";
import TopPlayerBySport from "../common/report/TopPlayerBySport";
import TotalFigures from "../common/report/TotalFigures";
import UserDeleted from "../common/report/UserDeleted";
import UserList from "../common/report/UserList";
import UserRights from "../common/report/UserRights";
import UsersActionLog from "../common/report/UsersActionLog";
import WagersListing from "../common/report/WagersListing";
import WagersOnGameReport from "../common/report/WagersOnGameReport";
import WebVsPhoneStats from "../common/report/WebVsPhoneStats";
import WeeklyBalance from "../common/report/WeeklyBalance";
import WeeklyPayments from "../common/report/WeeklyPayments";
import WinLossesBySource from "../common/report/WinLossesBySource";
import "./reportsMenu.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const TabPanel = memo((props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
});

const CATEGORIES = {
  financial: {
    title: "Financial",
    icon: "fa-coins",
    items: [
      { value: 0, rights: [460], icon: "fa-arrows-down-to-people", label: "Adjustment" },
      { value: 1, rights: [511], icon: "fa-user-tie", label: "Agent Per Head" },
      { value: 2, rights: [462], icon: "fa-chart-line", label: "Balance History By Agent" },
      { value: 3, rights: [489], icon: "fa-user", label: "Balance History By Player" },
      { value: 4, rights: [393], icon: "fa-gift", label: "Bonus Points (no data)", disabled: true },
      { value: 5, rights: [463], icon: "fa-cash-register", label: "Cash Flow" },
      { value: 6, rights: [490], icon: "fa-credit-card", label: "Cash Flow By Payment" },
      { value: 7, rights: [464], icon: "fa-sack-dollar", label: "Cash Flow By Source" },
      { value: 8, rights: [465], icon: "fa-calendar-day", label: "Daily Summary" },
      { value: 9, rights: [491], icon: "fa-chart-bar", label: "Daily Summary Chart" },
      { value: 10, rights: [397], icon: "fa-diagram-project", label: "Distribution Default" },
      { value: 11, rights: [398], icon: "fa-network-wired", label: "Distribution Details" },
      { value: 12, rights: [399], icon: "fa-calendar-week", label: "Gross Week" },
      { value: 13, rights: [400], icon: "fa-layer-group", label: "Grouping Balance" },
      { value: 14, rights: [401, 495], icon: "fa-handshake", label: "Settle" },
      { value: 15, rights: [402], icon: "fa-scale-unbalanced", label: "Total Figure" },
      { value: 16, rights: [497], icon: "fa-globe", label: "Web vs Phone Stats" },
      { value: 17, rights: [407], icon: "fa-calendar-alt", label: "Weekly Balance" },
      { value: 18, rights: [408], icon: "fa-wallet", label: "Weekly Payments" },
      { value: 19, rights: [409], icon: "fa-money-bill", label: "Win-Losses By Source" },
    ],
  },
  players: {
    title: "Players",
    icon: "fa-users",
    items: [
      { value: 20, rights: [423], icon: "fa-user", label: "Personal Info" },
      { value: 21, rights: [509], icon: "fa-chart-line", label: "Player Activity" },
      { value: 22, rights: [424, 492], icon: "fa-users", label: "Player Count By Agent Report" },
      { value: 23, rights: [425], icon: "fa-list", label: "Player Listing" },
      { value: 24, rights: [494], icon: "fa-trash", label: "Players Deleted" },
      { value: 25, rights: [426, 493], icon: "fa-trophy", label: "Top Player" },
      { value: 26, rights: [427], icon: "fa-futbol", label: "Top Player by Sport" },
    ],
  },
  agents: {
    title: "Agents",
    icon: "fa-user-tie",
    items: [
      { value: 27, rights: [389], icon: "fa-wallet", label: "Agent Balance" },
      { value: 28, rights: [390], icon: "fa-percent", label: "Agent Hold Percent" },
      { value: 29, rights: [391], icon: "fa-sack-dollar", label: "Agent Position" },
      { value: 30, rights: [392], icon: "fa-chart-line", label: "Distributor Hold Percent" },
    ],
  },
  games: {
    title: "Games",
    icon: "fa-dice-two",
    items: [
      { value: 31, rights: [420], icon: "fa-gamepad", label: "Changes By Game" },
      { value: 32, rights: [410], icon: "fa-chart-line", label: "Final Stats By Agent" },
      { value: 33, rights: [411], icon: "fa-circle-minus", label: "Game Deleted (no data)", disabled: true },
      { value: 34, rights: [412], icon: "fa-flag-checkered", label: "Game Score" },
      { value: 35, rights: [413], icon: "fa-play", label: "Game Started" },
      { value: 36, rights: [414], icon: "fa-clipboard-list", label: "Game Statistics" },
      { value: 37, rights: [417], icon: "fa-history", label: "Line History" },
      { value: 38, rights: [488], icon: "fa-user-clock", label: "Line History By Agent" },
      { value: 39, rights: [418], icon: "fa-chart-pie", label: "Statistics by Game" },
      { value: 40, rights: [416], icon: "fa-clock-rotate-left", label: "Time-Status Changes" },
    ],
  },
  wagers: {
    title: "Wagers",
    icon: "fa-address-book",
    items: [
      { value: 41, rights: [440], icon: "fa-gamepad", label: "Action by Game" },
      { value: 42, rights: [441], icon: "fa-user", label: "Action by Player" },
      { value: 44, rights: [443], icon: "fa-history", label: "Action History" },
      { value: 45, rights: [444], icon: "fa-percent", label: "Action Percent by Game" },
      { value: 46, rights: [445], icon: "fa-balance-scale", label: "At Risk By Agent" },
      { value: 47, rights: [446], icon: "fa-exchange-alt", label: "Changed Wagers" },
      { value: 48, rights: [447], icon: "fa-gift", label: "Free Plays" },
      { value: 49, rights: [448], icon: "fa-sack-dollar", label: "Gross Amount" },
      { value: 50, rights: [451], icon: "fa-layer-group", label: "Parlay-Teaser Exposure" },
      { value: 51, rights: [453], icon: "fa-clipboard-check", label: "Wager Claims (crash)", disabled: true },
      { value: 52, rights: [456], icon: "fa-list-alt", label: "Wagers Listing" },
      { value: 53, rights: [457], icon: "fa-gamepad", label: "Wagers on Game" },
    ],
  },
  system: {
    title: "System",
    icon: "fa-computer",
    items: [
      { value: 54, rights: [428], icon: "fa-exchange-alt", label: "Account Changes" },
      { value: 55, rights: [429], icon: "fa-phone", label: "Agent Calls Log" },
      { value: 56, rights: [430], icon: "fa-phone-volume", label: "Calls Log" },
      { value: 57, rights: [433], icon: "fa-envelope", label: "Mailing List" },
      { value: 58, rights: [542], icon: "fa-user-clock", label: "Session Log (no data)", disabled: true },
      { value: 59, rights: [434, 507], icon: "fa-sign-in-alt", label: "Sign on Status" },
      { value: 60, rights: [435], icon: "fa-user-plus", label: "Sign Up" },
      { value: 61, rights: [436], icon: "fa-chart-bar", label: "Summary Call Activity" },
      { value: 62, rights: [496], icon: "fa-user-minus", label: "User Deleted" },
      { value: 63, rights: [438], icon: "fa-tasks", label: "Users Action Log" },
      { value: 64, rights: [437], icon: "fa-list", label: "Users List" },
      { value: 65, rights: [439], icon: "fa-user-shield", label: "Users Rights" },
    ],
  },
};

function categoryForValue(value) {
  if (value >= 0 && value < 20) return "financial";
  if (value >= 20 && value < 27) return "players";
  if (value >= 27 && value < 31) return "agents";
  if (value >= 31 && value < 41) return "games";
  if (value >= 41 && value < 54) return "wagers";
  if (value >= 54 && value < 66) return "system";
  return null;
}

const Player = forwardRef(() => {
  const params = useQuery();
  let history = useHistory();

  const [compact, setCompact] = useState(false);
  const [value, setValue] = React.useState(() =>
    Number(params.get("report") ?? -1)
  );

  const handleChange = (event, newValue) => {
    params.set("report", newValue);
    history.push({ search: params.toString() });
    setValue(newValue);
    setCompact(newValue >= 0);
  };

  const reportParam = params.get("report");
  useEffect(() => {
    const newValue = Number(reportParam ?? -1);
    setValue(newValue);
    setCompact(newValue >= 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportParam]);

  const selectedCategory =
    params.get("category") || categoryForValue(value) || "financial";
  const category = CATEGORIES[selectedCategory] ?? CATEGORIES.financial;

  const drawerWidth = 240;
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      width: "100%",
    },

    root2: {
      width: "100%",
      useState,
      "& .MuiTextField-root2": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root2": {
        justifyContent: "center",
      },
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  }));

  const classes = useStyles();

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const visibleItems = useMemo(
    () => category.items.filter((item) => hasRights(...item.rights)),
    [category, hasRights]
  );

  return (
    <div className={classes.root}>
      <div
        className={`sub-menu flex flex-col h-screen col-span-3 !px-4 !py-6 bg-menu backdrop-blur-2xl border-r w-60 border-white/5 min-w-max relative transition-[width] duration-300 ease-in-out ${
          compact ? "compact" : ""
        }`}
      >
        <div
          onClick={() => setCompact(!compact)}
          className="absolute flex z-10 items-center justify-center p-1 bg-menu-contrast border !border-white/10 rounded-full leading-0 shadow-lg shadow-black/40 -right-3 top-1/8 w-7 h-7 transition-all duration-200 hover:scale-110 hover:bg-icon hover:[&>i]:text-white cursor-pointer"
        >
          <i
            className={`fa-solid leading-3  text-center text-gray-400 font-semibold text-xs ${
              compact ? "fa-chevron-right" : "fa-chevron-left"
            }`}
          ></i>
        </div>
        <div className="flex flex-col h-screen overflow-y-scroll">
          <div className="relative flex flex-col">
            <div className="flex items-center gap-2 px-2 mb-3 sidebar-title">
              <i className={`fa-solid ${category.icon} text-icon`}></i>
              <span className="text-sm font-bold tracking-wide text-white uppercase">
                {category.title}
              </span>
            </div>
            <div className="sub-collapsable">
              {visibleItems.map((item) => (
                <div
                  key={item.value}
                  className={`sub-link ${item.disabled ? "disabled" : ""} ${
                    value === item.value ? "active" : ""
                  }`}
                  onClick={(e) => handleChange(e, item.value)}
                >
                  <i className={`fa-solid ${item.icon}`}></i>
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Paper className={classes.root2}>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={0}
        >
          <Adjustment></Adjustment>
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={1}
        >
          <AgentPerHead />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={2}
        >
          <BalanceHistoryByAgent />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={3}
        >
          <BalanceHistoryByPlayer />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={4}
        >
          <GameStatistic></GameStatistic>
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={5}
        >
          <CashFlow />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={6}
        >
          <CashFlowByPayment />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={7}
        >
          <CashFlowBySource />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={8}
        >
          <DailySummary />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={9}
        >
          <DailySummaryChart />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={10}
        >
          <DistributionDefault />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={11}
        >
          <DistributionDetails />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={12}
        >
          <GrossWeek />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={13}
        >
          <GroupingBalance />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={14}
        >
          <Settle />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={15}
        >
          <TotalFigures />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={16}
        >
          <WebVsPhoneStats />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={17}
        >
          <WeeklyBalance />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={18}
        >
          <WeeklyPayments />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={19}
        >
          <WinLossesBySource />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={20}
        >
          <PersonalInfo />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={21}
        >
          <PlayerActivity />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={22}
        >
          <PlayerCountByAgent />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={23}
        >
          <PlayerListing />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={24}
        >
          <PlayerDeleted />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={25}
        >
          <TopPlayer />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={26}
        >
          <TopPlayerBySport />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={27}
        >
          <AgentBalance />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={28}
        >
          <AgentHoldPercent />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={29}
        >
          <AgentPosition />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={30}
        >
          <DistributionHoldPercent />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={31}
        >
          <ChangesByGame />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={32}
        >
          <FinalStatsByAgent />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={34}
        >
          <GameScore />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={35}
        >
          <GameStarted />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={36}
        >
          <GameStatistics />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={37}
        >
          <LineHistory />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={38}
        >
          <LineHistoryByAgent />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={39}
        >
          <StatisticsByGame />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={40}
        >
          <TimeStatusChanges />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={41}
        >
          <ActionByGame />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={42}
        >
          <ActionByPlayer />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={44}
        >
          <ActionHistory />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={45}
        >
          <ActionPercentByGame />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={46}
        >
          <AtRistkByAgent />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={47}
        >
          <ChangedWagers />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={48}
        >
          <FreePlays />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={49}
        >
          <GrossAmount />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={50}
        >
          <ParlayTeaserExposure />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={52}
        >
          <WagersListing />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={53}
        >
          <WagersOnGameReport />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={54}
        >
          <AccountChanges />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={55}
        >
          <AgentCallsLog />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={56}
        >
          <CallsLog />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={57}
        >
          <MailingList />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={59}
        >
          <SignOnStatus />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={60}
        >
          <SignUp />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={61}
        >
          <SummaryCallActivity />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={62}
        >
          <UserDeleted />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={63}
        >
          <UsersActionLog />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={64}
        >
          <UserList />
        </TabPanel>
        <TabPanel
          className="tab-content cell-top-align report-tab-content"
          value={value}
          index={65}
        >
          <UserRights />
        </TabPanel>
      </Paper>
    </div>
  );
});

export default Player;
